export default "__VITE_ASSET__iw2OPOoZ__"